import { z } from 'zod';
export const companyStatusSchema = z.union([z.literal('active'), z.literal('inactive')]);

export type Company = z.infer<typeof companySchema>;
export const companySchema = z.object({
  companyId: z.number(),
  name: z.string().max(150),
  status: companyStatusSchema,
  companyType: z.string(),
  projects: z.array(z.string()).optional(),
  users: z.array(z.string()).optional(),
});
